import {inject, Injectable} from "@angular/core";
import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";

export class ActiveDealValidationRequestData extends EntityData<ActiveDealValidationRequestData> {
    @field dealId: string;
    @field integratedDealConfigId: number;
    @field providerName: string;
    @field localDateTime: string;
}

@Injectable({providedIn: "root"})
export class ActiveDealValidationService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- ActiveDealValidationService");

        super(http, nameSpace, "active-deal-validation", configService, useAsync, actionNames);
    }
}
